import { PASSWORDS } from "../endpoints";
import api from "../api";

export default {
    update(data) {
        return api.put(PASSWORDS, data);
    }
}